module.exports = __webpack_public_path__ + "static/media/pic-laufrouten-3.394ab10d.jpg";